<template>
    <v-form :name="props.searchProps.formName"
            @keyup.enter="autoSearch = true">
        <Tabs value="0"
              scrollable>

            <TabList class="mb-4">
                <Tab value="0">{{ __('Basic data') }}</Tab>
            </TabList>

            <TabPanels>
                <TabPanel value="0">
                    <div class="grid">
                        <FormMultiselect fieldName="contractor_id"
                                         label="Contractor"
                                         size="4"
                                         :options="select?.contractors"
                                         v-model:field="search.contractor_id" />

                        <FormInputText fieldName="first_name"
                                       label="First name"
                                       size="4"
                                       v-model:field="search.first_name" />

                        <FormInputText fieldName="last_name"
                                       label="Last name"
                                       size="4"
                                       v-model:field="search.last_name" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="city"
                                       label="City"
                                       size="4"
                                       v-model:field="search.city" />

                        <FormInputText fieldName="address"
                                       label="Address"
                                       size="6"
                                       v-model:field="search.address" />

                        <FormInputText fieldName="postal_code"
                                       label="Postal code"
                                       size="2"
                                       v-model:field="search.postal_code" />
                    </div>
                    <div class="grid">
                        <FormInputText fieldName="phone"
                                       label="Phone"
                                       size="5"
                                       v-model:field="search.phone" />

                        <FormInputText fieldName="email"
                                       label="Email"
                                       size="5"
                                       validation="email"
                                       v-model:field="search.email" />

                        <FormSelect fieldName="is_active"
                                    label="Is active contractor?"
                                    size="2"
                                    scrollHeight="100px"
                                    :allowZero="true"
                                    :showClear="true"
                                    :filtering="false"
                                    :options="yesNoOptions()"
                                    v-model:field="search.is_active" />
                    </div>
                </TabPanel>
            </TabPanels>
        </Tabs>

        <div class="grid">
            <SearchButtons :searchProps="searchProps"
                           :search="search"
                           v-model:autoSearch="autoSearch" />
        </div>
    </v-form>
</template>

<script setup>
import { ref } from "vue";
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';

import FormInputText from '@crud/FormInputText.vue'
import FormMultiselect from '@crud/FormMultiselect.vue'
import FormSelect from '@crud/FormSelect.vue'
import SearchButtons from '@crud/SearchButtons.vue'
import { prepareSearch, yesNoOptions } from '@pages/Helper/crud_utils.js'
import { __ } from '@helper/utils.js'

// -----------------------------------------------------

const props = defineProps({
    searchProps: Object,
})
const autoSearch = ref(false)

let search = ref({})
const options = ["contractors"];
const select = ref(null);

prepareSearch(search, props, options, select)

// -----------------------------------------------------

</script>

<style lang="scss" scoped></style>
